/* Boneswimmer reviews: tabs, "show all", "read more" and the photo lightbox for
   sections/bs-reviews and sections/bs-collection-reviews. One delegated listener. */
(function () {
  if (window.__bsReviews) return;
  window.__bsReviews = true;

  /* Long review texts are clamped by CSS; add a "read more" button where text is cut. */
  function fit(scope) {
    (scope || document).querySelectorAll('.bs-review__text:not([data-bs-fit])').forEach(function (el) {
      if (!el.offsetParent) return;
      el.setAttribute('data-bs-fit', '');
      if (el.scrollHeight <= el.clientHeight + 4) { el.setAttribute('data-bs-open', ''); return; }
      var panel = el.closest('[data-bs-panel]');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bs-review__read';
      b.setAttribute('data-bs-read', '');
      b.textContent = (panel && panel.getAttribute('data-bs-read-label')) || 'Read more';
      el.after(b);
    });
  }

  function selectTab(tab) {
    var root = tab.closest('.bs-reviews');
    if (!root) return;
    root.querySelectorAll('[data-bs-tab]').forEach(function (b) {
      var on = b === tab;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('[data-bs-panel]').forEach(function (p) {
      p.hidden = p.id !== tab.getAttribute('aria-controls');
    });
    fit(root);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var tab = t.closest('[data-bs-tab]');
    if (tab) { selectTab(tab); return; }

    var read = t.closest('[data-bs-read]');
    if (read) {
      var text = read.previousElementSibling;
      if (text) text.setAttribute('data-bs-open', '');
      read.remove();
      return;
    }

    var more = t.closest('[data-bs-more]');
    if (more) {
      var panel = more.closest('[data-bs-panel]');
      var extra = panel ? panel.querySelectorAll('[data-bs-extra]') : [];
      extra.forEach(function (li) { li.hidden = false; });
      more.hidden = true;
      fit(panel);
      if (extra[0]) { extra[0].setAttribute('tabindex', '-1'); extra[0].focus({ preventScroll: true }); }
      return;
    }

    var photo = t.closest('[data-bs-photo]');
    if (photo) {
      var root = photo.closest('.bs-reviews');
      var box = root && root.querySelector('[data-bs-lightbox]');
      if (!box || !box.showModal) return;
      e.preventDefault();
      var pic = box.querySelector('img');
      var thumb = photo.querySelector('img');
      pic.src = photo.href;
      pic.alt = thumb ? thumb.alt : '';
      box.showModal();
      return;
    }

    var open = t.closest('[data-bs-lightbox]');
    if (open && (t === open || t.closest('[data-bs-close]'))) open.close();
  });

  /* Boneswimmer 03.11.2026 (speed): measuring every review text forces a layout of the whole page; do it when the
     reviews come near the screen (1000 px ahead), not during page load. Same buttons, same order. */
  function start() {
    var boxes = document.querySelectorAll('.bs-reviews');
    if (!boxes.length || !('IntersectionObserver' in window)) { fit(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      fit();
    }, { rootMargin: '1000px 0px' });
    boxes.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { fit(e.target); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var tab = e.target.closest && e.target.closest('[data-bs-tab]');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[data-bs-tab]'));
    var next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    if (next) { e.preventDefault(); selectTab(next); next.focus(); }
  });
})();


/* 26.10.2026: the reviews are written in Italian (shop in Gallarate, Google profile). On the other languages each text
   gets a small "Translate" button: Chrome's built-in translator (Translator API) translates it in place, other browsers
   open Google Translate with the text. "Original" switches back. Nothing runs on Italian pages. */
(function () {
  if (window.__bsReviewsTr) return;
  window.__bsReviewsTr = true;
  var lang = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
  if (lang === 'it') return;
  var L = {
    en: ['Translate', 'Original (Italian)'], de: ['Übersetzen', 'Original (Italienisch)'],
    fr: ['Traduire', 'Original (italien)'], es: ['Traducir', 'Original (italiano)'],
    nl: ['Vertalen', 'Origineel (Italiaans)'], pl: ['Przetłumacz', 'Oryginał (włoski)'],
    pt: ['Traduzir', 'Original (italiano)']
  }[lang] || ['Translate', 'Original (Italian)'];
  var tr = null;

  function add(scope) {
    (scope || document).querySelectorAll('.bs-review__text:not([data-bs-tr])').forEach(function (el) {
      el.setAttribute('data-bs-tr', '');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bs-review__tr';
      b.setAttribute('data-bs-trb', '');
      b.textContent = L[0];
      var anchor = el.nextElementSibling && el.nextElementSibling.matches('[data-bs-read]') ? el.nextElementSibling : el;
      anchor.after(b);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bs-trb]');
    if (!b) return;
    var box = b.closest('.bs-review__what') || b.parentNode;
    var el = box.querySelector('.bs-review__text');
    if (!el) return;
    if (el.hasAttribute('data-bs-orig')) {            /* back to the original */
      el.innerHTML = el.getAttribute('data-bs-orig');
      el.removeAttribute('data-bs-orig');
      b.textContent = L[0];
      return;
    }
    var text = el.innerText;
    var gt = function () { window.open('https://translate.google.com/?sl=it&tl=' + lang + '&op=translate&text=' + encodeURIComponent(text), '_blank', 'noopener'); };
    if (!('Translator' in self) || !self.Translator.availability) { gt(); return; }
    /* in place only when the language pack is already on the device; otherwise Google Translate in a new tab
       (a first-time download can take minutes and would leave the button hanging) */
    b.disabled = true;
    self.Translator.availability({ sourceLanguage: 'it', targetLanguage: lang })
      .then(function (a) {
        if (a !== 'available') throw new Error(a);
        return tr || (tr = self.Translator.create({ sourceLanguage: 'it', targetLanguage: lang }));
      })
      .then(function (t) { return t.translate(text); })
      .then(function (out) {
        el.setAttribute('data-bs-orig', el.innerHTML);
        el.textContent = out;
        el.setAttribute('data-bs-open', '');
        b.textContent = L[1];
      })
      .catch(function () { tr = null; gt(); })
      .then(function () { b.disabled = false; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { add(); });
  else add();
  document.addEventListener('shopify:section:load', function (e) { add(e.target); });
  /* "show all" reveals hidden reviews: buttons are already there (added to every text on load) */
})();
